import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { InfoboxComponent } from '@core/components-infobox-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import type { ScorecardsResult } from '@core/interview-results-types';

import { InterviewResultSummaryScorecardsItemComponent } from './interview-result-summary-scorecards-item/interview-result-summary-scorecards-item.component';

@Component({
  selector: 'rt-interview-result-summary-scorecards',
  templateUrl: 'interview-result-summary-scorecards.component.html',
  styleUrls: ['./interview-result-summary-scorecards.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InterviewResultSummaryScorecardsItemComponent, TranslatePipe, InfoboxComponent],
})
export class InterviewResultSummaryScorecardsComponent {
  public readonly scorecardsResults = input<ScorecardsResult[]>(undefined!);
  public readonly hasHiddenResults = input<boolean>(false);

  public trackByScorecard(index: number, scorecard: ScorecardsResult): string {
    return JSON.stringify(scorecard);
  }
}
